import { useEffect } from "react";


// HOOKS
import { useAuth } from "../../hooks/useAuth";


export default function Logout(){

    const {logout} = useAuth();

    useEffect(() => {
        logout();        
    }, [])
}